// src/routes/DriverRoutes.tsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import DriverLayout from '../components/layout/DriverLayout';
import DriverDashboard from '../pages/Driver/Dashboard';
import DriverCashSummary from '../pages/Driver/CashSummary';

const DriverRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<DriverLayout />}>
        <Route index element={<DriverDashboard />} />
        <Route path="cash" element={<DriverCashSummary />} />
        <Route path="orders" element={<div>Driver Orders (Coming Soon)</div>} />
        <Route path="profile" element={<div>Driver Profile (Coming Soon)</div>} />
      </Route>
    </Routes>
  );
};

export default DriverRoutes;